import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function AuthCallback() {
  const { loginWithGoogle } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get("session_id");
    window.history.replaceState(null, "", window.location.pathname);
    loginWithGoogle(sessionId)
      .then((u) => navigate(u.role === "admin" ? "/dashboard" : "/miei-lavori", { replace: true }))
      .catch((e) => {
        toast.error(formatApiError(e));
        navigate("/login", { replace: true });
      });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return <div className="min-h-screen bg-slate-50" data-testid="auth-callback" />;
}
